<template>
    <div>
        <v-select v-model="entity.condicionIva" :items="condicionesIva" value="nombre" outlined item-text="nombre"
            item-value="id" :label="label" name="condición iva" :clearable="!required" v-validate="reglas"
            :error-messages="errors.collect('condicionIva')" data-vv-name="condicionIva"></v-select>
    </div>
</template>

<script>
export default {
    name: 'CondicionIvaVSelect',
    $_veeValidate: {
    validator: "new",
  },
    props: {
        entity: {
            type: Object,
            required: true,
        },
        // Hay altas (proveedores) donde la condicion de IVA se completa despues.
        required: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            condicionesIva: null,

        }
    },
    computed: {
        reglas() {
            return this.required ? 'required' : '';
        },
        label() {
            return this.required ? 'Condición de iva *' : 'Condición de iva';
        },
    },
    methods: {
        async fetchCondicionIva() {
            try {
                const response = await this.axios.get(`/comprobantes/condicionIva`);

                this.condicionesIva = response.data;
            } catch (error) { }
        },
    },
    created() {
        this.fetchCondicionIva();
    },
}
</script>

<style lang="scss" scoped></style>